import React from 'react';
import {
  Container,
  Stack,
  Flex,
  Box,
  Heading,
  Text,
  Button,
  Image,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaArrowRight, FaBuilding, FaChartLine, FaHandshake } from 'react-icons/fa';

export default function HeroSection() {
  return (
    <Container maxW={'7xl'} id="hero">
      <Stack
        align={'center'}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 20, md: 28 }}
        direction={{ base: 'column', md: 'row' }}
      >
        <Stack flex={1} spacing={{ base: 5, md: 10 }}>
          <Heading
            lineHeight={1.1}
            fontWeight={600}
            fontSize={{ base: '3xl', sm: '4xl', lg: '6xl' }}
          >
            <Text
              as={'span'}
              position={'relative'}
              _after={{
                content: "''",
                width: 'full',
                height: '30%',
                position: 'absolute',
                bottom: 1,
                left: 0,
                bg: 'brand.400',
                zIndex: -1,
              }}
            >
              Building Tomorrow's
            </Text>
            <br />
            <Text as={'span'} color={'brand.500'}>
              Infrastructure Today
            </Text>
          </Heading>
          <Text color={'gray.500'} fontSize={'lg'}>
            Mesh Infrastructure Group is a leading infrastructure development and consulting firm 
            dedicated to creating sustainable, innovative solutions for modern urban challenges. 
            We transform communities through strategic planning and cutting-edge technology.
          </Text>
          <Stack
            spacing={{ base: 4, sm: 6 }}
            direction={{ base: 'column', sm: 'row' }}
          >
            <Button
              rounded={'full'}
              size={'lg'}
              fontWeight={'normal'}
              px={6}
              colorScheme={'brand'}
              bg={'brand.500'}
              _hover={{ bg: 'brand.600' }}
              rightIcon={<FaArrowRight />}
            >
              Get Started
            </Button>
            <Button
              rounded={'full'}
              size={'lg'}
              fontWeight={'normal'}
              px={6}
              variant="outline"
              borderColor="brand.500"
              color="brand.500"
              _hover={{ bg: 'brand.50' }}
            >
              Learn More
            </Button>
          </Stack>

          <Stack direction={{ base: 'column', md: 'row' }} spacing={4} mt={8}>
            <Flex align="center">
              <Icon as={FaBuilding} color="brand.500" boxSize={5} mr={2} />
              <Text fontWeight="bold">500+ Projects</Text>
            </Flex>
            <Flex align="center">
              <Icon as={FaHandshake} color="brand.500" boxSize={5} mr={2} />
              <Text fontWeight="bold">200+ Partners</Text>
            </Flex>
            <Flex align="center">
              <Icon as={FaChartLine} color="brand.500" boxSize={5} mr={2} />
              <Text fontWeight="bold">15+ Years Experience</Text>
            </Flex>
          </Stack>
        </Stack>
        <Flex
          flex={1}
          justify={'center'}
          align={'center'}
          position={'relative'}
          w={'full'}
        >
          <Box
            position={'relative'}
            height={'400px'}
            rounded={'2xl'}
            boxShadow={'2xl'}
            width={'full'}
            overflow={'hidden'}
            bg="brand.500"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Text
              color="white"
              fontSize="6xl"
              fontWeight="bold"
              textAlign="center"
            >
              MESH
            </Text>
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bgGradient="linear(to-br, brand.400, brand.600)"
              opacity={0.8}
            />
          </Box>
        </Flex>
      </Stack>
    </Container>
  );
}